<template>
    <v-container fluid>
        <Overlay />
        <v-row
            align="center"
            justify="center"
        >
            <v-col
                cols="12"
                md="11"
                class="d-flex flex-row justify-space-between align-center"
            >
                <h1>Create Field</h1>
            </v-col>
        </v-row>

        <v-row
            align="start"
            justify="center"
            class="d-flex flex-row justify-center"
        >
            <v-col
                cols="12"
                md="11"
                justify="center"
            >
                <FieldEditForm mode="create" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import FieldEditForm from './FieldEditForm';
import Overlay from '../../../../components/Overlay';

export default {
    components: { Overlay, FieldEditForm },
};
</script>
